import * as React from "react";
import { Globe } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

export const languages = [
  { code: "pl", label: "PL", flag: "🇵🇱" },
  { code: "en", label: "EN", flag: "🇬🇧" },
  { code: "de", label: "DE", flag: "🇩🇪" },
];

export const LanguageSwitchButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement> & { className?: string }
>(({ className, ...props }, ref) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = React.useState(false);

  const currentLang = languages.find(l => l.code === i18n.language) || languages[0];

  const handleLangChange = (code: string) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="relative">
      <button
        ref={ref}
        className={cn(
          "flex items-center gap-2 px-2 py-1 rounded-md hover:bg-navy-light bg-navy transition text-foreground font-semibold",
          className
        )}
        onClick={() => setOpen((v) => !v)}
        type="button"
        aria-label="Change language"
      >
        <Globe className="w-5 h-5" />
        {/* <span className="text-base">{currentLang.flag}</span> */}
        {/* <span className="hidden md:inline">{currentLang.label}</span> */}
        <svg
          className={`ml-1 w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`}
          viewBox="0 0 10 6"
          fill="none"
        >
          <path d="M1 1L5 5L9 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </button>
      {open && (
        <div className="absolute right-0 mt-1 w-28 bg-navy shadow-xl rounded-lg z-50 border border-steel/20 animate-fade-in">
          {languages.map((lang) => (
            <button
              key={lang.code}
              className={cn(
                "flex w-full items-center gap-1 px-4 py-2 text-foreground rounded-lg hover:bg-navy-light focus:bg-blue-500/10 transition font-medium text-sm",
                i18n.language === lang.code && "font-bold bg-navy"
              )}
              onClick={() => handleLangChange(lang.code)}
            >
              <span>{lang.flag}</span>
              {lang.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
});
LanguageSwitchButton.displayName = "LanguageSwitchButton";
